import { type QueryKey } from '@tanstack/react-query'
import { type WidgetGetInput, type WidgetListInput } from '@terros/common'

export const widgetKey = (props?: WidgetGetInput): QueryKey => {
  if (!props) return ['widget']
  return ['widget', props]
}
export const widgetListKey = (props?: WidgetListInput): QueryKey => {
  if (!props) return ['widgets']
  return ['widgets', props]
}
